import { Dialog, IconButton, DialogTitle, DialogContent, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/system'
import { toast } from 'react-toastify'

import '../contactos/modalContacts.css'

import { SeccionGeneralCat } from './SeccionGeneralCat'
import { useForm } from '../../hooks/useForm2'
// import { useCatalog } from '../../hooks/useCatalog'

export const DialogProfileCatalogCat = ({ open, setOpen, initialState, handleNewCat, handleUpdateCat, initLoadCategorias }) => {

    const { form, onInputChange, onResetForm } = useForm(initialState)
    // const [saveAndExitCat, setSaveAndExitCat] = useState('')

    const handleSubmitCat = async (modo) => {

        if (form.nombre === '') {
            toast.warn("Ingrese nombre categoría")
            return false
        }

        if (form.id > 0) {
            handleUpdateCat(form)
        } else {
            handleNewCat(form)
            if (modo === 'saveAndMore') {
                onResetForm({
                    id: 0,
                    nombre: '',
                    tipo: 'venta'
                })
            }
            if (modo === 'saveAndExit') {
                setOpen(false)
            }
        }

        initLoadCategorias()
    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            {/* <form onSubmit={handleSubmitCat} encType="multipart/form-data"> */}
            <DialogTitle id="scroll-dialog-title">

                {form.id > 0 ?
                    <div>Detalle categoría <span className="text-uppercase">( {form.nombre} )</span></div>
                    :
                    `Nueva categoría ${form.nombre !== '' ? `( ${form.nombre} )` : ''}`
                }

                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>

            </DialogTitle>

            <DialogContent>

                <TabsContacto
                    initialState={initialState}
                    form={form}
                    onInputChange={onInputChange}
                    handleSubmitCat={handleSubmitCat}
                />

            </DialogContent>

            {/* </form> */}
        </Dialog>
    )
}

const TabsContacto = ({ initialState, form, onInputChange, handleSubmitCat }) => {
    // const [value, setValue] = React.useState(0)
    const value = 0

    // const handleChangeTab = (event, newValue) => {
    //     setValue(newValue)
    // }

    return (
        <Box sx={{ width: '100%' }}>
            {/* <Box sx={{ borderBottom: '1px solid #FCF1FF' }}>
                <Tabs value={value} onChange={handleChangeTab} aria-label="basic tabs example">
                    <Tab label="Información general" {...a11yProps(0)} style={{ textTransform: 'capitalize' }} />
                </Tabs>
            </Box> */}
            <TabPanel value={value} index={0}>
                <SeccionGeneralCat
                    initialState={initialState}
                    form={form}
                    onInputChange={onInputChange}
                    handleSubmitCat={handleSubmitCat}
                />
            </TabPanel>
        </Box >
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component={'div'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

// function a11yProps(index) {
//     return {
//         id: `simple-tab-${index}`,
//         'aria-controls': `simple-tabpanel-${index}`,
//     };
// }